export enum EvaluationChartTableFormLabel {
  EvaluationChartId = '번호',
  RegisteredChartName = '(회차) 회차명',
  ChartTypeName = '차트 종류',
  LastModifiedAt = '최종 작성일',
  EvaluationAvgScore = '평가결과',
}

export enum PatientDetailSortByFormLabel {
  LastModifiedAt = '최종 작성일',
  EvaluationAvgScore = '평가결과',
}

export enum EvaluationChartFeedbackFormField {
  EvaluationChartId = 'evaluationChartId',
  Score = 'score',
  FeedbackContent = 'feedbackContent',
  FeedbackImage = 'feedbackImage',
}

export type TEvaluationChartFeedbackFormValues = {
  [EvaluationChartFeedbackFormField.EvaluationChartId]: number | null;
  [EvaluationChartFeedbackFormField.Score]: number | null;
  [EvaluationChartFeedbackFormField.FeedbackContent]?: string | undefined;
  [EvaluationChartFeedbackFormField.FeedbackImage]?: string | undefined;
};
